<template>
  <el-container class="app_index_container">
    <el-header height="46px" class="header_container">
      <div class="website_name">{{ setting.cms_website_name || '' }}</div>
      <div class="login_container">
        <template v-if="isLogined">
          <el-dropdown size="large" @command="handleDropdownCommand">
            <div class="dropdown_text">
              <div class="login_icon">
                <template v-if="isNotEmpty(headPicUrl)">
                  <el-image :src="headPicUrl" class="img" />
                </template>
                <template v-else>
                  <svg-icon icon-class="icon-user" />
                </template>
              </div>
              <div class="login_name">{{ userInfo.name }}</div>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="info">个人信息</el-dropdown-item>
                <el-dropdown-item command="change_pwd" v-if="isNotEmpty(userInfo.login_id)">修改密码</el-dropdown-item>
                <el-dropdown-item command="account_setting" v-else>设置账号</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
        <template v-else>
          <div class="login_icon">
            <svg-icon icon-class="icon-user" />
          </div>
          <div class="login_name" @click="handleClickLogin">登录</div>
        </template>
      </div>
    </el-header>
    <el-main class="app_main_container">
      <div class="banner_container">
        <el-image :src="bg" />
      </div>
      <div class="search_container">
        <el-select size="default" v-model="searchArea" class="search_select"
                   :suffix-icon="suffixIcon">
          <el-option :label="currColumn.name" value="curr" />
          <el-option label="本站" value="all" />
        </el-select>
        <el-input size="default" type="text" class="search_input" clearable
                  v-model="searchValue" placeholder="请输入查询内容"
                  @keyup.enter.native="handleSearch()" @change="handleChange">
          <template #append>
            <svg-icon icon-class="icon-search" class-name="search_icon"
                      @click="handleSearch()" />
          </template>
        </el-input>
      </div>
      <div class="column_container">
        <div class="column_first" v-if="isNotEmptyList(firstColumnList)">
          <div class="column_item"  v-for="(item, index) in firstColumnList" :key="index"
               :class="{ active: currColumn.sid === item.sid }"
               @click="handleClickItem(item)">
            <template v-if="isNotEmpty(item.icon_url)">
              <el-image :src="item.icon_path" class="column_icon" />
            </template>
          </div>
        </div>
        <div class="column_other" v-if="isNotEmptyList(otherColumnList)">
          <div class="column_item" v-for="(item, index) in otherColumnList" :key="index"
               :class="{ active: currColumn.sid === item.sid }"
               @click="handleClickItem(item)">{{ item.name }}</div>
        </div>
      </div>
      <div class="doc_container">
        <app-doc-list @event="handleListEvent" />
      </div>
    </el-main>
    <template v-if="isNotEmpty(setting.cms_copyright)">
      <el-footer class="footer_container">
        <div class="footer">
          <span>{{ setting.cms_copyright }}</span>&nbsp;&nbsp;<span v-html="setting.beian_html"></span>
        </div>
      </el-footer>
    </template>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import { markRaw, defineAsyncComponent } from 'vue';
import { CaretTop } from '@element-plus/icons-vue';
import bg from '../../assets/images/bg.png';

export default {
  name: "AppIndex",
  components: {
    Banner: defineAsyncComponent(() => import('@components/banner')),
    AppDocList: defineAsyncComponent(() => import('../components/AppDocList.vue')),
  },
  data() {
    return {
      searchValue: '',
      searchArea: '',
      bannerList: [],
      suffixIcon: markRaw(CaretTop),
      bg,
    };
  },
  computed: {
    ...mapState([ 'setting', 'currColumn', 'columnList', 'userInfo' ]),
    ...mapState('techBlue', [ 'search_value' ]),
    isLogined() {
      return this.userInfo && this.isNotEmpty(this.userInfo.sid);
    },
    firstColumnList() {
      return this.columnList.filter((item, index) => item.location === 'middle' && index <= 1);
    },
    otherColumnList() {
      let filter = this.columnList.filter((item, index) => item.location === 'middle' && index > 1);
      let topColumn = this.columnList.filter(item => item.location === 'top');
      if (this.isNotEmptyList(topColumn)) {
        filter = filter.concat(topColumn);
      }
      return filter;
    },
    headPicUrl() {
      if (this.isNotEmpty(this.userInfo.head_pic)) {
        let head_pic = this.userInfo.head_pic;
        if (this.isNotEmpty(head_pic) && head_pic.indexOf('http://') === -1
            && head_pic.indexOf('https://') === -1) {
          head_pic = this.getFileUrl(head_pic);
        }
        return head_pic;
      }
      return '';
    }
  },
  watch: {
    currColumn: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    init() {
      this.initBanner();
      this.searchValue = '';
      this.searchArea = 'curr';
    },
    initBanner() {
      this.bannerList = [];
      if (this.isNotEmpty(this.currColumn.ad_url_json)) {
        let list = JSON.parse(this.currColumn.ad_url_json);
        if (this.isNotEmptyList(list)) {
          list.forEach(item => {
            if (this.isNotEmpty(item.icon_url)) {
              item.icon_path = this.getFileUrl(item.icon_url);
            }
            if (this.isNotEmpty(item.main_pic_url)) {
              item.main_pic_path = this.getFileUrl(item.main_pic_url);
            }
          });
        }
        this.bannerList = list;
      }
    },
    handleBannerEvent(event) {
      if (event.type === 'detail') {
        this.handleOpenDetail(event.data);
      }
    },
    handleListEvent(event) {
      if (event.type === 'clickItem') {
        this.handleOpenDetail(event.data);
      }
    },
    handleChange(val) {
      if (this.isEmpty(val)) {
        this.handleSearch();
      }
    },
    handleSearch() {
      const _this = this;
      _this.storeCommit('techBlue/SET_SEARCH_VALUE', this.searchValue);
    },
    handleClickItem(item) {
      const _this = this;
      _this.storeCommit('SET_CURR_COLUMN', item);
    },
    handleOpenDetail(item) {
      if (item.is_ex === 1) {
        if (this.isNotEmpty(item.ex_url)) {
          window.open(item.ex_url);
        }
        return;
      }
      this.$router.push({
        path: `/app_detail/${ item.static_url }`,
      });
    },
    handleClickLogin() {
      this.$emit('event', { type: 'clickLogin' });
    },
    handleDropdownCommand(command) {
      if (command === 'logout') {
        this.storeCommit('SET_USER_INFO', {});
        this.storeCommit('SET_ACCESS_TOKEN', {});
        return;
      }
      this.$emit('event', { type: command });
    },
  },
}
</script>

<style scoped lang="scss">
.app_index_container {
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;


  .header_container {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .website_name {
      font-size: 16px;
      font-weight: 400;
      color: #000;
    }

    .login_container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #666;

      .login_icon {
        margin-right: 5px;
      }

      :deep(.dropdown_text) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .app_main_container {
    padding: 0;

    .banner_container {
    }

    .search_container {
      width: calc(100% - 24px);
      margin: 10px auto;

      .search_select {
        width: 100px;

        :deep(.el-input) {
          .el-input__inner {
            height: 34px;
            line-height: 34px;
            border-radius: 17px 0 0 17px;
            background-color: #fff;
            border: none;
            text-align: center;
            font-size: 12px;
            font-weight: 600;
            color: #333;
            padding-left: 10px;
            padding-right: 20px;
          }

          .el-input__suffix {
            right: 4px;

            .el-input__icon {
              color: #333;
            }
          }
        }
      }

      .search_input {
        position: relative;
        width: calc(100% - 100px);

        :deep(.el-input__inner) {
          height: 34px;
          line-height: 34px;
          border-radius: 0;
          background-color: #fff;
          border: none;
          font-size: 12px;
          font-weight: 500;
          color: #333;
          padding-right: 20px;
        }

        :deep(.el-input__suffix) {
          right: 3px;
        }

        :deep(.el-input-group__append) {
          border: 0;
          background-color: #fff;
          border-radius: 0 17px 17px 0;
          padding: 0 10px;

          .search_icon {
            font-size: 20px;
            margin: 7px 0;
            color: #333;
            cursor: pointer;
          }
        }

        &:before {
          content: " ";
          width: 1px;
          height: 16px;
          background-color: #B0B0B0;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }

    .column_container {
      width: calc(100% - 24px);
      margin: 0 auto;

      .column_first {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 15px;
        margin-bottom: 15px;

        .column_item {
          height: 124px;
          border-radius: 8px;
          background-color: #fff;
          cursor: pointer;

          .column_icon {
            width: 100%;
            height: 100%;
          }

          &.active {
            position: relative;

            &:before {
              content: ' ';
              width: calc(100% - 10px);
              height: 2px;
              background-color: #0A7AFF;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }

      .column_other {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 15px;
        margin-bottom: 15px;

        .column_item {
          width: 100%;
          padding: 10px 0;
          border-radius: 8px;
          background-color: #fff;
          text-align: center;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;

          &.active {
            position: relative;

            &:before {
              content: ' ';
              width: calc(100% - 10px);
              height: 2px;
              background-color: #0A7AFF;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
          }
        }
      }
    }

    .doc_container {
      width: calc(100% - 24px);
      margin: 10px auto;
    }
  }

  .footer_container {
    height: auto;
    padding: 10px;
    text-align: center;
    background-color: #434655;
    color: #fff;
    font-size: 14px;
  }
}
</style>
